export default function(){
    (function($) {
        $('.anchor__file').click(function () {
            $(this).toggleClass('anchor__file-clicked');
        });

        //copy anchor link to clipboard on click
        $('.anchor').click(function () {
            $(this).addClass("animate").delay(100).queue(function(next) {
                $(this).removeClass("animate");
                next();
            });
            let str = window.location.href.split("#")[0] + '#' + $(this).attr('id');
            const el = document.createElement('textarea');
            el.value = str;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        })



    })(jQuery);
}




